import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { showToast } from 'Core/redux/toast/slice';
import { closeModal, showModal } from 'Core/redux/main/slice';
import { redux } from 'Core/redux';
import { saveAs } from 'Core/utils';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { selectStatusLoading } from '../../../core/redux/status/selectors';
import { ProductionService } from '../../../service/api/production-service';
const { PRODUCTION_ADD_EDIT } = MODAL_TYPES;

export const STORE_KEY = 'production';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  product: null,
  printersdata: [],
  filters: {
    status: {
      value: 'In Production',
      label: 'In Production',
    },
    searchText: '',
  },
  filterVisible: false,
  tileView: true,
  selectedProduction: null,
  editModalVisible: false,
};

export const fetchProductions = createAsyncThunk(
  'production/fetchProductions',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.getAllProduction(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load Productions');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Productions');
    }
  },
);

export const getPrinters = createAsyncThunk(
  'production/getPrinters',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.getPrinters(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load Printers');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Printers');
    }
  },
);

export const printlabel = createAsyncThunk(
  'production/printlabel',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.printlabel(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to print');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to print');
    }
  },
);
export const scrapcatalog = createAsyncThunk(
  'production/scrapcatalog',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.scrapcatalog(filters)
      if (response.status === 200) {
        return response.response
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to print')
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to print')
    }
  },
);
export const printlabelfornotinproduction = createAsyncThunk(
  'production/printlabelfornotinproduction',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.printlabelfornotinproduction(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to print');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to print');
    }
  },
);
export const scanlabel = createAsyncThunk(
  'production/scanlabel',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.scanlabel(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to print');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to print');
    }
  },
);
export const reprintlabel = createAsyncThunk(
  'production/reprintlabel',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.reprintlabel(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to print');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to print');
    }
  },
);
export const lostlabelreprint = createAsyncThunk(
  'production/lostlabelreprint',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.lostlabelreprint(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to print');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to print');
    }
  },
);
export const printcustomlabels = createAsyncThunk(
  'production/printcustomlabels',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.printcustomlabels(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to print');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to print');
    }
  },
);
export const labelquantitysplitter = createAsyncThunk(
  'production/labelquantitysplitter',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.labelquantitysplitter(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to print');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to print');
    }
  },
);

export const addProduction = createAsyncThunk(
  'production/addProduction',
  async (productionPayload, { rejectWithValue }) => {
    try {
      const response = await ProductionService.createProduction(productionPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to add Productions');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add Productions');
    }
  },
);

export const editProduction = createAsyncThunk(
  'production/editProduction',
  async (productionPayload, { rejectWithValue }) => {
    try {
      const response = await ProductionService.createProduction(productionPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to update production');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update production');
    }
  },
);

export const downloadProductions = createAsyncThunk(
  'production/downloadProductions',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ProductionService.downloadProduction(filters);
      const blob = response;
      saveAs(blob, `Productions.xlsx`);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to download Productions');
    }
  },
);

export const deleteProduction = createAsyncThunk(
  'production/deleteProduction',
  async (productionId, { rejectWithValue }) => {
    try {
      const response = await ProductionService.deleteProduction(productionId);
      if (response.status === 200) {
        return productionId;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to delete production');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete production');
    }
  },
);

export const fetchProductionsWithFilters = () => (dispatch, getState) => {
  const filters = getState().production.filters;
  dispatch(
    fetchProductions({
      // searchText: filters.searchText,
      status: filters.status.value,
    }),
  );
};

export const downloadProductionsWithFilters = () => (dispatch, getState) => {
  const filters = getState().production.filters;
  dispatch(
    downloadProductions({
      searchText: filters.searchText,
      customer: filters?.customer?.value,
      status: filters?.status?.value,
      productionDate: filters?.shipDate,
    }),
  );
};

export const fetchProductionSerialData = createAsyncThunk(
  'production/fetchProductionSerialData',
  async (production, { rejectWithValue }) => {
    try {
      const response = await ProductionService.getProductionById(production.partId);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load shipment data');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load shipment data');
    }
  },
);

export const quarantineProduction = createAsyncThunk(
  'production/quarantineinv',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ProductionService.Quarantine(payload);
      if (response.status === 200) {
        return payload;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to quarantine');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to quarantine');
    }
  },
);

export const releaseProduction = createAsyncThunk(
  'production/releaseinv',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ProductionService.Release(payload);
      if (response.status === 200) {
        return payload;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to release production');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to release production');
    }
  },
);

export const { reducer, actions } = createSlice({
  name: 'production',
  initialState: INITIAL_STATE,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setProduct: (state, action) => {
      state.product = action.payload;
    },
    resetFilters: state => {
      state.filters = INITIAL_STATE.filters;
    },
    setFilterVisible: (state, action) => {
      state.filterVisible = action.payload;
    },
    setSearchText: (state, action) => {
      state.filters.searchText = action.payload;
    },
    setCustomer: (state, action) => {
      state.filters.customer = action.payload;
    },
    setStatus: (state, action) => {
      state.filters.status = action.payload;
    },
    setStartDate: (state, action) => {
      state.filters.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.filters.endDate = action.payload;
    },
    setTileView: (state, action) => {
      state.tileView = action.payload; // Add reducer to update tileView
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchProductions.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductions.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProductions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPrinters.pending, state => {
        state.printersloading = true;
        state.printerserror = null;
      })
      .addCase(getPrinters.fulfilled, (state, action) => {
        state.printersloading = false;
        state.printersdata = action.payload;
      })
      .addCase(getPrinters.rejected, (state, action) => {
        state.printersloading = false;
        state.printerserror = action.payload;
      })

      .addCase(printlabel.pending, state => {
        state.productSubmitloading = true;
      })
      .addCase(printlabel.fulfilled, (state, action) => {
        state.productSubmitloading = false;
      })
      .addCase(printlabel.rejected, (state, action) => {
        state.productSubmitloading = false;
      })

      .addCase(scrapcatalog.pending, state => {
        state.productSubmitloading = true;
      })
      .addCase(scrapcatalog.fulfilled, (state, action) => {
        state.productSubmitloading = false;
      })
      .addCase(scrapcatalog.rejected, (state, action) => {
        state.productSubmitloading = false;
      })

      .addCase(printlabelfornotinproduction.pending, state => {
        state.productSubmitloading = true;
      })
      .addCase(printlabelfornotinproduction.fulfilled, (state, action) => {
        state.productSubmitloading = false;
      })
      .addCase(printlabelfornotinproduction.rejected, (state, action) => {
        state.productSubmitloading = false;
      })

      .addCase(scanlabel.pending, state => {
        state.productSubmitloading = true;
      })
      .addCase(scanlabel.fulfilled, (state, action) => {
        state.productSubmitloading = false;
      })
      .addCase(scanlabel.rejected, (state, action) => {
        state.productSubmitloading = false;
      })

      .addCase(reprintlabel.pending, state => {
        state.productSubmitloading = true;
      })
      .addCase(reprintlabel.fulfilled, (state, action) => {
        state.productSubmitloading = false;
      })
      .addCase(reprintlabel.rejected, (state, action) => {
        state.productSubmitloading = false;
      })

      .addCase(lostlabelreprint.pending, state => {
        state.productSubmitloading = true;
      })
      .addCase(lostlabelreprint.fulfilled, (state, action) => {
        state.productSubmitloading = false;
      })
      .addCase(lostlabelreprint.rejected, (state, action) => {
        state.productSubmitloading = false;
      })

      .addCase(printcustomlabels.pending, state => {
        state.productSubmitloading = true;
      })
      .addCase(printcustomlabels.fulfilled, (state, action) => {
        state.productSubmitloading = false;
      })
      .addCase(printcustomlabels.rejected, (state, action) => {
        state.productSubmitloading = false;
      })

      .addCase(labelquantitysplitter.pending, state => {
        state.productSubmitloading = true;
      })
      .addCase(labelquantitysplitter.fulfilled, (state, action) => {
        state.productSubmitloading = false;
      })
      .addCase(labelquantitysplitter.rejected, (state, action) => {
        state.productSubmitloading = false;
      })

      .addCase(addProduction.fulfilled, (state, action) => {
        const newProduction = {
          ...action.payload,
          isNewlyCreated: true,
        };
        state.data = [newProduction, ...state.data];
      })
      .addCase(addProduction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(editProduction.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editProduction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchProductionSerialData.pending, state => {
        state.productionLoading = true;
        state.productionError = null;
      })
      .addCase(fetchProductionSerialData.fulfilled, (state, action) => {
        state.productionLoading = false;
        state.productionData = action.payload;
      })
      .addCase(fetchProductionSerialData.rejected, (state, action) => {
        state.productionLoading = false;
        state.productionError = action.payload;
      })
      .addCase(deleteProduction.fulfilled, (state, action) => {
        const newData = state.data.filter(s => s.id !== action.payload);
        state.data = newData;
      });
  },
});

redux.listener.startListening({
  matcher: isAnyOf(
    addProduction.rejected,
    editProduction.rejected,
    fetchProductionSerialData.rejected,
    quarantineProduction.rejected,
    releaseProduction.rejected,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload,
        type: 'danger',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addProduction.fulfilled, editProduction.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(PRODUCTION_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'Production saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(quarantineProduction.fulfilled, releaseProduction.fulfilled),
  effect: (action, listenerApi) => {
    selectStatusLoading(false);
    listenerApi.dispatch(
      showToast({
        message: 'Production saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addProduction.fulfilled, editProduction.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(PRODUCTION_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'Production saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(
    printlabel.fulfilled,
    scrapcatalog.fulfilled,
    printlabelfornotinproduction.fulfilled,
    scanlabel.fulfilled,
    reprintlabel.fulfilled,
    lostlabelreprint.fulfilled,
    printcustomlabels.fulfilled,
    labelquantitysplitter.fulfilled,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload.message || 'Action Successful',
        type: !action.payload.responseCode || action.payload.responseCode > 0 ? 'success' : 'danger',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(
    printlabel.rejected,
    scrapcatalog.rejected,
    printlabelfornotinproduction.rejected,
    scanlabel.rejected,
    reprintlabel.rejected,
    lostlabelreprint.rejected,
    printcustomlabels.rejected,
    labelquantitysplitter.rejected,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload || 'Action Failed',
        type: 'danger',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(fetchProductionSerialData.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(showModal(PRODUCTION_ADD_EDIT, action.payload));
  },
});

redux.listener.startListening({
  matcher: isAnyOf(deleteProduction.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: 'Production deleted successfully',
        type: 'success',
      }),
    );
  },
});

redux.injectReducer(STORE_KEY, reducer);
